import { createGlobalStyle } from "styled-components";

// GenericTable and SelectableTable both render a plain antd Table with no styled-components wrapper of
// their own (adding one would break ResourceManagerWrapper's `& > .ant-table-wrapper` direct-child layout
// selector), so they can't reuse the `&.aevi-table ...` rules in BaseTableStyle/AntdTableStyle, which only
// apply to PropertyTable's `<TableStyle>`-wrapped instances. This targets antd's own classes directly via
// a global style instead. Safe to mount from multiple components - styled-components dedupes the CSS.
export const TableCursorStyle = createGlobalStyle`
    .aevi-table .ant-table-tbody > tr > td {
        cursor: default;
    }

    .aevi-table .ant-table-tbody > tr.aevi-table-row--clickable > td {
        cursor: pointer;
    }
`;
